import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-381d0de6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title-img"
};
const _hoisted_2 = {
  class: "title-text"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'LeHealthListItem',
  props: {
    data: null
  },
  setup(__props) {
    const props = __props;
    const goRoute = () => {
      window.open(props.data.route, '_blank');
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", {
        class: "le-health-list-item",
        onClick: goRoute
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
        width: "100%",
        height: "100%",
        src: props.data.iconUrl
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(props.data.title), 1)])]);
    };
  }
});